export enum ValidDocTypes {
  custom_checks = 'custom_checks',
}

export enum ValidMimeTypes {
  bmp = 'image/bmp',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  gif = 'image/gif',
  heic = 'image/heic',
  heif = 'image/heif',
  jpeg = 'image/jpeg',
  doc = 'application/msword',
  pdf = 'application/pdf',
  plainText = 'text/plain',
  png = 'image/png',
  tiff = 'image/tiff',
  webp = 'image/webp',
}
